import { Minus } from "@phosphor-icons/react"

export default Minus
